import { render, staticRenderFns } from "./giftBox.vue?vue&type=template&id=1d75b5bc&scoped=true&"
import script from "./giftBox.vue?vue&type=script&lang=js&"
export * from "./giftBox.vue?vue&type=script&lang=js&"
import style0 from "./giftBox.vue?vue&type=style&index=0&id=1d75b5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d75b5bc",
  null
  
)

export default component.exports